import React, { useState, useEffect } from 'react'
import { EligiblityTrophy, Professor } from '../../assets/index'
import '../../styles/EligibilityCriteria.css'

const EligiblityCreteria = () => {

    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const steps = [
        "Click on 'Create an Account' and register yourself by providing your basic details.",
        "After login, proceed to pay Application Form Fees - Rs. 500",
        "You can use UPI, Internet Banking, Debit Card and Credit Card for making the online payment After successful payment, you need to fill the application form.",
        "Once the application form is submitted, the Admission Department will communicate the GD and PI dates along with FBS's internal aptitude test schedule.",
        "In case you clear the selection process, you will receive the communication from the Admission Department regarding the further registration process."
    ];
    return (
        <div className="w-full" id="eb-container">
            {/* All sections remain identical except for height adjustments */}
            <div className="mx-auto px-3" id="eb-1-container">
                {/* Overview section - exactly the same */}
                {/* Keep everything exactly as is */}

                <div className="oline" id="oline"></div>
                <p className="ovr" id="ovr">
                    Overview
                </p>



                <div className="flex flex-col md:flex-row mx-auto gap-6 relative top-[4rem] sm:right-[2rem]" id="left-container">
                    <div className="h-auto flex flex-col">
                        <div className="text-lg text-justify h-auto md:w-[55rem] lg:w-[50rem] relative lg:right-[7.5rem]" id="pr">
                            {/* Text remains the same */}
                            <p>
                                Imagine working on real-life projects, analyzing financial data,
                                and developing strategies to drive business growth. You'll have
                                the opportunity to work with experienced finance professionals,
                                gaining invaluable insights and practical skills that will prepare
                                you for a successful career in the finance industry.
                            </p>
                        </div>
                        <div className="w-full lg:w-[67rem] lg:h-[22.5rem] md:w-[64rem] h-auto md:h-[19rem] lg:-mx-[15rem] bg-gray-200 relative lg:right-[10rem] top-[1.5rem] md:-left-[8rem] px-4 md:px-0" id="pr1">
                            <p className="relative md:left-[8rem] md:top-[1rem] lg:mx-[7rem] text-lg w-full lg:w-[50rem] md:w-[55rem] text-justify py-4 md:py-0">
                                {/* Long text content remains exactly the same */}
                                The Practical MBA program offers a comprehensive approach to
                                business education, blending rigorous coursework with practical
                                experiences. Participants have the opportunity to gain one year
                                of valuable job experience, giving them a competitive edge in the
                                job market. Additionally, the program provides certifications
                                covering various crucial business areas. Alongside this,
                                participants receive focused training in soft skills and other
                                valuable sessions. Through hands-on learning & a customizable
                                curriculum, participants develop critical thinking & problem
                                solving abilities. The program also fosters networking
                                opportunities, preparing individuals to thrive in the ever-evolving
                                business landscape. Join the Practical MBA to unlock your
                                business potential, acquire real-world experience, earn
                                certifications, and enhance your soft skills.
                            </p>
                        </div>
                    </div>
                    <div className="w-full md:w-[25rem] lg:w-[45rem] lg:h-[34rem] relative lg:right-[10rem] min-h-[300px] sm:min-h-[300px] md:min-h-full flex items-start h-full md:right-[4rem]" id="aks">
                        <div className="sticky top-0 w-[100%] sm:w-full mx-auto h-[calc(100%-3rem)] rounded-lg overflow-hidden transition-transform duration-500 transform hover:scale-105">
                            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/50 to-transparent z-10 w-full sm:w-[1500px]" />
                            <img
                                src={Professor}
                                alt="Akhilesh Sir"
                                className="relative lg:right-[0rem] w-full h-[23.5rem] md:h-full object-contain rounded-lg opacity-0 animate-fadeIn"
                            />
                        </div>
                    </div>
                </div>
                <style jsx>{`
                    @keyframes fadeIn {
                        0% {
                            opacity: 0;
                        }
                        100% {
                            opacity: 1;
                        }
                    }
                    .animate-fadeIn {
                        animation: fadeIn 1s ease-in forwards;
                    }
                `}</style>
            </div>

            <div className={`transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} id='applycontainer'>
                <div className="relative" id="howtoapplycont">
                    <div className="oline" id="oline"></div>
                    <h1 className={`text-orange-500 font-semibold text-2xl sm:text-3xl md:text-4xl relative bottom-[4rem] left-6 sm:left-24 md:left-24 lg:left-32 xl:left-36 px-4 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`} id='ovr'>
                        How To Apply?
                    </h1>
                </div>

                <div className="relative top-[20rem] space-y-6 max-w-4xl" id="hta">
                    <div className={`space-y-2 transition-all duration-700 delay-900 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
                        <p className="text-base sm:text-lg">
                            Visit{" "}
                            <a
                                href="https://fbsedu.in"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:text-blue-700 transition-colors hover:scale-105 transform duration-300"
                            >
                                www.fbsedu.in
                            </a>{" "}
                            and click on apply now or you can directly visit our online
                            admission portal
                        </p>
                        <br></br>
                        <a
                            href="https://fbsedu.in/#/register"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-xl text-blue-600 hover:text-blue-700 transition-colors hover:scale-105 transform duration-300"
                        >
                            www.fbsedu.in/register
                        </a>
                    </div>

                    <ul className="space-y-4 pl-4">
                        {steps.map((step, index) => (
                            <li
                                key={index}
                                className={`flex items-start gap-3 text-base sm:text-lg transition-all duration-500 hover:translate-x-2 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}
                                style={{ transitionDelay: `${700 + index * 150}ms` }}
                            >
                                <span className="text-orange-500 font-bold flex-shrink-0 transform transition-transform duration-300 hover:scale-125">✓</span>
                                <span>{step}</span>
                            </li>
                        ))}
                    </ul>

                    <div className={`text-base sm:text-lg transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                        style={{ transitionDelay: `${1500}ms` }}
                    >
                        <p>
                            The candidates who wish to pursue MBA program have to appear for FBS 2025 Test Schedule on 5th of Every Month in a year or can apply with scores from 2025 onwards of{" "}
                            <span className="font-bold hover:text-orange-500 transition-colors duration-300">
                                GMAT™/ CAT/ NMAT/ CMAT/ MAT/ MH CET/ XAT.
                            </span>
                        </p>
                    </div>
                </div>
            </div>

            <div className='eb-2-Container' id='eb-2-Container'>
                <div className="relative" id="eb-heading">
                    <div className="oline" id="oline"></div>
                    <h1 className={`text-orange-500 font-semibold text-2xl sm:text-3xl md:text-4xl relative bottom-[4rem] left-6 sm:left-24 md:left-24 lg:left-32 xl:left-36 px-4 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`} id='ovr'>
                        Eligibility Criteria
                    </h1>
                </div>
                <div className="eb-content">
                    <ul className="left-content">
                        {[
                            "Graduation Degree In Any Stream.",
                            "B.COM/ M.COM Students",
                            "BBA/ BCA/ MCA Students",
                            "CAT/MAT/XAT/MH-CET/CET/CMAT Aspirants & Coaching Classes.",
                            "Bachelor of Arts (BA) / Master of Arts (MA).",
                            "BE/ B.TECH/ M.TECH",
                            "Bachelor of Science (B.Sc) / Master of Science (M.Sc)",
                            "CA Aspirant Students",
                            "Consultant, Counsellors"
                        ].map((text, index, array) => (
                            <li
                                key={index}
                                className={`relative bg-white transition-all duration-700 transform
                                ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-[-50px] opacity-0'}`}
                                style={{ transitionDelay: `${index * 100}ms` }}
                            >
                                <div className="flex items-start my-3 group hover:bg-orange-50 rounded-lg p-2 transition-all duration-300">
                                    <div className="w-6 h-6 rounded-full border-2 border-orange-500 flex items-center justify-center mr-2 flex-shrink-0
                                        group-hover:scale-110 group-hover:bg-orange-500 group-hover:text-white transition-all duration-300">
                                        <span className="text-orange-500 text-sm font-bold group-hover:text-white">✓</span>
                                    </div>
                                    <span className="text-base sm:text-lg group-hover:text-orange-600 transition-colors duration-300">{text}</span>
                                </div>
                                {index !== array.length - 1 && (
                                    <div className="border-b border-dotted border-gray-400 w-full my-2"></div>
                                )}
                            </li>

                        ))}
                    </ul>

                    {/* Mobile View (Hidden on lg and above) */}
                    <div
                        className={`block lg:hidden relative transition-all duration-1000 transform 
              ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-[50px] opacity-0'}`}
                        id="responsive-image"
                    >
                        <div className="relative">
                            <div className="absolute inset-0 pointer-events-none h-[50rem]" />
                            <img
                                src={EligiblityTrophy}
                                alt="success"
                                className="w-full h-full object-cover md:bg-white md:opacity-100 transition-transform duration-700 hover:scale-105"
                            />
                        </div>
                    </div>

                    {/* Laptop/Desktop View (Hidden on sm and below) */}
                    <div
                        className={`hidden lg:block transition-all duration-1000 transform 
              ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-[50px] opacity-0'}`}
                        id="responsive-image"
                    >
                        <div className="relative hover:shadow-2xl transition-shadow duration-300">
                            <div className="absolute inset-0 pointer-events-none" />
                            <img
                                src={EligiblityTrophy}
                                alt="success"
                                className="w-full h-full object-cover md:bg-white md:opacity-100 transition-transform duration-700 hover:scale-105"
                            />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default EligiblityCreteria